/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./SignupInfo.css";

class SignupInfo extends Component {
  render() {
    return (
      <div className="SignupInfo-view">
        <div className="SignupInfo-prompt">
          <a href="/selectMission">
            <div className="SignupInfo-back">
              <div className="SignupInfo-backBtn"></div>
              <div className="SignupInfo-backText">返回</div>
            </div>
          </a>

          <div className="SignupInfo-logo">L O G O</div>

          <div className="SignupInfo-text">請輸入以下資料</div>

          <div className="SignupInfo-inputFieldContainer">
            <input
              type="text"
              className="SignupInfo-inputField"
              placeholder="請輸入你的姓氏"
            />
          </div>

          <div className="SignupInfo-errorContainer">
            <div className="SignupInfo-errorIndicator"></div>
            <div className="SignupInfo-errorMessage">請輸入你的姓氏。</div>
          </div>

          <div className="SignupInfo-inputFieldContainer">
            <input
              type="text"
              className="SignupInfo-inputField"
              placeholder="請輸入你的名字"
            />
          </div>

          <div className="SignupInfo-errorContainer">
            <div className="SignupInfo-errorIndicator"></div>
            <div className="SignupInfo-errorMessage">請輸入你的名字。</div>
          </div>

          <div className="SignupInfo-chin"></div>

          <a href="/emailVerification">
            <div className="SignupInfo-nextBtn">下一步</div>
          </a>

          <div className="SignupInfo-chin"></div>
        </div>
      </div>
    );
  }
}

export default SignupInfo;
